import { useEffect } from 'react';

/**
 * 预览图片时禁止右键菜单
 * @param visible 预览显示开关
 * @param enable 是否启用右键菜单功能，默认为禁用
 */
export function useDisableContextMenu(visible: boolean, enable = false): void {
  useEffect(() => {
    const disableContextMenu = (event: MouseEvent): void => {
      event.preventDefault();
    };

    if (visible && !enable) {
      document.addEventListener('contextmenu', disableContextMenu);
    } else {
      document.removeEventListener('contextmenu', disableContextMenu);
    }
    return (): void => {
      document.removeEventListener('contextmenu', disableContextMenu);
    };
  }, [visible, enable]);
}
